import { Routes } from '@angular/router';
import { ClientAddPageComponent } from './features/client/components/client-add-page/client-add-page.component';
import { ClientDetailsPageComponent } from './features/client/components/client-details-page/client-details-page.component';
import { TherapistLoginPageComponent } from './features/login/components/login-page/therapist-login-page.component';
import { therapistAuthCanMatch } from './shared/guards/therapist-auth.guard';
import { therapistSubscriptionCanMatch } from './shared/guards/therapist-subscription.guard';
import { HomePageComponent } from './features/home/home-page/home-page.component';
import { TherapyPlanAddNewPageComponent } from './features/therapy-plan/pages/therapy-plan-add-new-page/therapy-plan-add-new-page.component';
import { TherapyPlanDetailsPageComponent } from './features/therapy-plan/pages/therapy-plan-details-page/therapy-plan-details-page.component';
import {
  TherapyPlanAddOrEditExercisesPageComponent
} from './features/therapy-plan/pages/therapy-plan-add-or-edit-exercise-page/therapy-plan-add-or-edit-exercises-page.component';
import {
  TherapyPlanAddOrEditDataPageComponent
} from './features/therapy-plan/pages/therapy-plan-add-or-edit-details-page/therapy-plan-add-or-edit-data-page.component';
import { therapistClientReadyGuard } from './shared/guards/therapist-client-ready.guard';
import { therapistTherapyPlanReadyGuard } from './shared/guards/therapist-therapy-plan-ready.guard';
import { NotFoundPageComponent } from './features/error/pages/not-found-page/not-found-page.component';
import { PasswordRequestResetComponent } from './features/password/components/password-request-reset/password-request-reset.component';
import { PasswordResetComponent } from './features/password/components/password-reset/password-reset.component';
import { RegisterPageComponent } from './features/register/components/register-page/register-page.component';
import { SubscriptionPageComponent } from './features/subscription/pages/subscription-page/subscription-page.component';

export const sanaTherapistAppRoutes: Routes = [
  {
    path: 'login',
    loadComponent: () => TherapistLoginPageComponent
  },
  {
    path: 'register',
    loadComponent: () => RegisterPageComponent
  },
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () => HomePageComponent,
    canMatch: [therapistAuthCanMatch, therapistSubscriptionCanMatch]
  },
  {
    path: 'client/add',
    loadComponent: () => ClientAddPageComponent,
    canMatch: [therapistAuthCanMatch, therapistSubscriptionCanMatch]
  },
  {
    path: 'client/:clientId',
    loadComponent: () => ClientDetailsPageComponent,
    canActivate: [therapistClientReadyGuard],
    canMatch: [therapistAuthCanMatch, therapistSubscriptionCanMatch],
    runGuardsAndResolvers: 'paramsOrQueryParamsChange'
  },
  {
    path: 'client/:clientId/therapy-plan/:therapyPlanId/details',
    loadComponent: () => TherapyPlanDetailsPageComponent,
    canActivate: [
      therapistClientReadyGuard,
      therapistTherapyPlanReadyGuard
    ],
    canMatch: [therapistAuthCanMatch, therapistSubscriptionCanMatch],
    runGuardsAndResolvers: 'paramsOrQueryParamsChange'
  },
  {
    path: 'client/:clientId/therapy-plan/add',
    loadComponent: () => TherapyPlanAddNewPageComponent,
    canActivate: [therapistClientReadyGuard],
    canMatch: [therapistAuthCanMatch, therapistSubscriptionCanMatch],
    runGuardsAndResolvers: 'paramsOrQueryParamsChange'
  },
  {
    path: 'client/:clientId/therapy-plan/add/exercises',
    loadComponent: () => TherapyPlanAddOrEditExercisesPageComponent,
    canActivate: [therapistClientReadyGuard],
    canMatch: [therapistAuthCanMatch, therapistSubscriptionCanMatch],
    runGuardsAndResolvers: 'paramsOrQueryParamsChange'
  },
  {
    path: 'client/:clientId/therapy-plan/add/data',
    loadComponent: () => TherapyPlanAddOrEditDataPageComponent,
    canActivate: [therapistClientReadyGuard],
    canMatch: [therapistAuthCanMatch, therapistSubscriptionCanMatch],
    runGuardsAndResolvers: 'paramsOrQueryParamsChange'
  },
  {
    path: 'client/:clientId/therapy-plan/:therapyPlanId/edit',
    loadComponent: () => TherapyPlanAddOrEditExercisesPageComponent,
    canActivate: [
      therapistClientReadyGuard,
      therapistTherapyPlanReadyGuard
    ],
    canMatch: [therapistAuthCanMatch, therapistSubscriptionCanMatch],
    runGuardsAndResolvers: 'paramsOrQueryParamsChange'
  },
  {
    path: 'client/:clientId/therapy-plan/:therapyPlanId/edit/exercises',
    loadComponent: () => TherapyPlanAddOrEditExercisesPageComponent,
    canActivate: [
      therapistClientReadyGuard,
      therapistTherapyPlanReadyGuard
    ],
    canMatch: [therapistAuthCanMatch, therapistSubscriptionCanMatch],
    runGuardsAndResolvers: 'paramsOrQueryParamsChange'
  },
  {
    path: 'client/:clientId/therapy-plan/:therapyPlanId/edit/data',
    loadComponent: () => TherapyPlanAddOrEditDataPageComponent,
    canActivate: [
      therapistClientReadyGuard,
      therapistTherapyPlanReadyGuard
    ],
    canMatch: [therapistAuthCanMatch, therapistSubscriptionCanMatch],
    runGuardsAndResolvers: 'paramsOrQueryParamsChange'
  },
  {
    // ohne Abo-Guard: Ziel der Weiterleitung für gesperrte Therapeuten
    path: 'subscription',
    loadComponent: () => SubscriptionPageComponent,
    canMatch: [therapistAuthCanMatch]
  },
  {
    path: 'password/password-request-reset',
    component: PasswordRequestResetComponent
  },
  {
    path: 'password/password-reset',
    component: PasswordResetComponent
  },
  {
    path: '404',
    loadComponent: () => NotFoundPageComponent
  }
];
